import { contextFactory } from '@frontend/design-system';
import { UseWritebackSettingsResults } from './useWritebackSettings';

export const [DigitalFormsWritebackSettingsContext, useDigitalFormsWritebackSettingsContext] =
  contextFactory<UseWritebackSettingsResults>(
    'useDigitalFormsWritebackSettingsContext must be used within a DigitalFormsWritebackSettingsContext'
  );
